var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "事务特性-acid"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#事务特性-acid"
    }
  }, [_vm._v("#")]), _vm._v(" 事务特性: ACID")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://zh.wikipedia.org/wiki/ACID",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://zh.wikipedia.org/wiki/ACID"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Atomicity（原子性）：一个事务中的所有操作，或者全部完成，或者全部不完成，不会结束在中间某个环节。事务在执行过程中发生错误，会被回滚（Rollback）到事务开始前的状态，就像这个事务从来没有执行过一样。即，事务不可分割、不可约简。")]), _vm._v(" "), _c('li', [_vm._v("Consistency（一致性）：在事务开始之前和事务结束以后，数据库的完整性没有被破坏。这表示写入的资料必须完全符合所有的预设约束、触发器、级联回滚等。")]), _vm._v(" "), _c('li', [_vm._v("Isolation（隔离性）：数据库允许多个并发事务同时对其数据进行读写和修改的能力，隔离性可以防止多个事务并发执行时由于交叉执行而导致数据的不一致。事务隔离分为不同级别，包括未提交读（Read uncommitted）、提交读（read committed）、可重复读（repeatable read）和串行化（Serializable）。")]), _vm._v(" "), _c('li', [_vm._v("Durability（持久性）：事务处理结束后，对数据的修改就是永久的，即便系统故障也不会丢失。")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "事务隔离级别"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#事务隔离级别"
    }
  }, [_vm._v("#")]), _vm._v(" 事务隔离级别")]), _vm._v(" "), _c('p', [_vm._v("事务的隔离级别，属于 ACID 中的 Isolation（隔离性）")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("未提交读（READ UNCOMMITTED）\n最低的隔离级别，事务可以看到其他事务“尚未提交”的修改，会产生“脏读”（dirty reads）")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("提交读（READ COMMITTED）\n一个事务提交之后，数据变更才可以被其他事务马上看到")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("可重复读（REPEATABLE READS）\n一个事务提交之后，数据变更才会被其他事务看到。但是另一个事务执行过程中，看到的数据总是一致的，直到当前事务提交，才能看到最新值，会产生“幻读”（phantom reads）")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("可串行化（SERIALIZABLE）\n要求在选定对象上的读锁和写锁保持直到事务结束后才能释放，可以避免“幻读”（phantom reads）")])])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("脏读：一个事务能读取另外一个事务修改但未提交的数据")]), _vm._v(" "), _c('p', [_vm._v("不可重复读：在一次事务中，一行数据查询两遍得到不同的结果")]), _vm._v(" "), _c('p', [_vm._v("幻读：在事务执行过程中，当两个完全相同的查询语句执行得到不同的结果集。这种现象称为“幻影读（phantom read）\n参考："), _c('a', {
    attrs: {
      "href": "https://zh.wikipedia.org/wiki/%E4%BA%8B%E5%8B%99%E9%9A%94%E9%9B%A2",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://zh.wikipedia.org/wiki/事務隔離"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("隔离级别")]), _vm._v(" "), _c('th', [_vm._v("脏读")]), _vm._v(" "), _c('th', [_vm._v("不可重复读")]), _vm._v(" "), _c('th', [_vm._v("幻读")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("未提交读")]), _vm._v(" "), _c('td', [_vm._v("可能")]), _vm._v(" "), _c('td', [_vm._v("可能")]), _vm._v(" "), _c('td', [_vm._v("可能")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提交读")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("可能")]), _vm._v(" "), _c('td', [_vm._v("可能")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("可重复读")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("可能")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("可串行化")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "事务隔离的实现"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#事务隔离的实现"
    }
  }, [_vm._v("#")]), _vm._v(" 事务隔离的实现")]), _vm._v(" "), _c('p', [_vm._v("在 InnoDB 里，每个事务启动会先申请一个 transaction id，transaction id 是顺序递增的，并根据 transaction id 为所有数据生成一个快照视图（read-view），这个快照只是一个逻辑数据，并不是物理磁盘的数据不需要额外占用物理空间，这就是数据库的多版本并发控制（MVCC）。也就是数，一条记录会有多个版本，在不同事务隔离级别下会根据数据的版本计算可见范围。")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "查询数据库隔离级别"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#查询数据库隔离级别"
    }
  }, [_vm._v("#")]), _vm._v(" 查询数据库隔离级别")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("查询当前回话事务隔离级别")]), _vm._v(" "), _c('div', {
    staticClass: "language-sql line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-sql"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("SELECT")]), _vm._v(" @"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("@session.tx_isolation")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("-- 或")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("SELECT")]), _vm._v(" @"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("@tx_isolation")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("-- MySQL 8")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("SELECT")]), _vm._v(" @"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("@transaction_isolation")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br')])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("查询全局事务隔离级别")]), _vm._v(" "), _c('div', {
    staticClass: "language-sql line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-sql"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("select")]), _vm._v(" @"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("@global.transaction_isolation")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(",")]), _vm._v(" @"), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("@transaction_isolation")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("-- 或")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("show")]), _vm._v(" variables "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("like")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'%tx_isolation%'")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("-- 修改事务级别（重启后失效，需要再服务器修改配置文件）")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("GLOBAL")]), _vm._v(" tx_isolation"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'READ-COMMITTED'")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "修改事务级别"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#修改事务级别"
    }
  }, [_vm._v("#")]), _vm._v(" 修改事务级别")]), _vm._v(" "), _c('div', {
    staticClass: "language-sql line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-sql"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("-- 修改事务级别")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("GLOBAL")]), _vm._v(" tx_isolation"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'READ-COMMITTED'")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('p', [_vm._v("修改服务器配置（防止重启后配置还原）")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("[mysqld]\ntransaction-isolation=READ-COMMITTED\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "如何选择事务隔离级别"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#如何选择事务隔离级别"
    }
  }, [_vm._v("#")]), _vm._v(" 如何选择事务隔离级别")]), _vm._v(" "), _c('p', [_vm._v("读未提交（数据不一致）和串行化（并发度低）一般是不会选择的，那么就是在 RC 和 RR 中选择。")]), _vm._v(" "), _c('p', [_vm._v("通常在性能要求较高的场景中会选择使用 RC + binlog(row)组合。")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("RR 会产生间隙锁，锁粒度更大，更容易造成死锁")]), _vm._v(" "), _c('li', [_vm._v("RC 的并发度低于 RR，性能更高")])]), _vm._v(" "), _c('p', [_vm._v("参考："), _c('a', {
    attrs: {
      "href": "https://time.geekbang.org/column/article/75173",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://time.geekbang.org/column/article/75173"), _c('OutboundLink')], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };